module.exports = __webpack_public_path__ + "static/media/Stedman-Logo-sm.f7826885.jpg";